import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const AgreedPlaceIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_agreedplaceillustration_svg_a)"
      d="m32.178 128 29.244-5.066-5.689-2.667-29.155 4.889z"
      opacity={0.5}
    />
    <path fill="#FDDE84" d="m104 68 84.711-15.111-48.267-33.156-84.71 15.111z" />
    <path fill="#753D0B" d="m61.422 122.933-5.689-2.666V34.845l5.69 3.733z" />
    <path fill="#894B0C" d="M61.422 38.578v84.355l84.622-15.288V23.378z" />
    <g fill="#000" opacity={0.05}>
      <path
        d="M61.244 102.756v.888l-5.51-2.844v-.711zM61.244 109.867v.8L55.734 108v-.8zM61.244 116.889v.889l-5.51-2.756v-.8zM61.244 95.022v.711l-5.51-2.666v-.89zM61.244 87.645v.71l-5.51-2.755v-.8zM61.244 80.267v.622l-5.51-2.667V77.6zM61.244 72.356v.8l-5.51-2.845v-.622zM61.422 64.8v.622l-5.689-2.666v-.8zM61.422 56.533v.89l-5.689-2.756v-.8zM61.244 116.889v.889l84.8-15.289v-.889zM61.244 109.867v.8l84.8-15.29v-.8z"
        opacity={0.05}
      />
      <path
        d="M61.244 102.756v.889l84.8-15.29v-.888zM61.244 95.022v.711l84.889-15.288v-.89zM61.244 87.644v.712l84.8-15.29v-.888zM61.244 80.267v.622l84.889-15.111V64.8zM61.244 72.356v.8l84.889-15.29v-.8zM61.244 64.8v.622l84.8-15.288v-.8zM61.244 56.534v.888l84.889-15.377v-.8zM61.244 49.156v.622l84.8-15.289v-.8zM61.244 49.156v.622l-5.51-2.667v-.8z"
        opacity={0.05}
      />
    </g>
    <path
      fill="url(#dhl__illustrations_agreedplaceillustration_svg_b)"
      d="m99.289 131.556 8.889-1.867-14.933-7.378L84.267 124z"
      opacity={0.5}
    />
    <path fill="#FDDE84" d="m108.178 105.778 26.578-4.711-15.111-7.378-26.4 4.711z" />
    <path fill="#AA7B33" d="m101.778 102.667 26.578-4.711-2.489-1.245-26.578 4.711z" opacity={0.4} />
    <path fill="#C39000" d="M108.178 105.778v23.911l-14.933-7.378v-23.91z" />
    <path fill="#AA7B33" d="M101.778 102.667v5.155l-2.49-1.333v-5.067z" opacity={0.4} />
    <path fill="#FCCE09" d="M108.178 105.778v23.911l26.578-4.711v-23.911z" />
    <path fill="#fff" d="M116.089 115.733v8.889l15.467-2.666v-8.889z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M124.978 121.422a69 69 0 0 0 2.666-.533v-5.422c-.8.178-1.866.355-2.666.533zM117.422 122.667c.8-.178 1.511-.356 2.311-.356v-5.422c-.8.178-1.511.356-2.311.356zM122.311 121.778c.356 0 .711-.178 1.156-.178v-5.422c-.356 0-.711.178-1.156.178zM130.044 115.2c-.355 0-.711.178-1.155.178v5.422c.355 0 .711-.178 1.155-.178zM121.156 122.134h.533v-5.423h-.533z"
      clipRule="evenodd"
    />
    <path fill="#9E5A11" d="m104 144.178-5.6-2.667V64.089L104 68z" />
    <path fill="#D08533" d="M104 68v76.178l6.044-1.156V66.933z" />
    <path fill="#9E5A11" d="m182.667 130.044-5.511-2.666V49.956l5.511 3.91z" />
    <path fill="#D08533" d="M182.667 53.867v76.177l6.044-1.155v-76z" />
    <g fill="#000" opacity={0.05}>
      <path
        d="M182.667 109.333v.711l-5.511-2.844v-.711zM182.667 116.444v.623l-5.511-2.667v-.889zM182.667 123.467v.711l-5.511-2.756v-.8zM182.667 101.422v.711l-5.511-2.666v-.89zM182.667 94.044v.8L177.156 92v-.622zM182.667 86.667v.8l-5.511-2.845V84zM182.667 78.933v.622l-5.511-2.844v-.622zM182.667 71.2v.8l-5.511-2.844v-.8zM182.667 63.111v.711l-5.511-2.755v-.8zM182.667 123.467v.711l6.044-.889v-.8zM182.667 116.444v.623l6.044-.8v-.889zM182.667 109.333v.711l6.044-.889v-.8zM182.667 101.422v.711l6.044-.889v-.8zM182.667 94.044v.8l6.044-.977v-.8zM182.667 86.667v.8l6.044-.8V85.6zM182.667 78.933v.623l6.044-.8v-.89zM182.667 71.2v.8l6.044-.978v-.889zM182.667 63.111v.711l6.044-.889v-.8z"
        opacity={0.05}
      />
    </g>
    <path
      fill="#000"
      d="M104 123.822v.622l-5.6-2.666v-.8zM104 130.844v.889l-5.6-2.844v-.711zM104 137.956v.8l-5.6-2.845v-.8zM104 115.911v.8l-5.6-2.844v-.623zM104 108.711v.622l-5.6-2.844v-.711zM104 101.244v.711l-5.6-2.844V98.4zM104 93.333v.711l-5.6-2.666v-.89zM104 85.6v.889l-5.6-2.845v-.71zM104 77.6v.8l-5.6-2.844v-.712zM104 137.956v.8l6.044-.978v-.889zM104 130.844v.889l6.044-1.066v-.8zM104 123.822v.622l6.044-.8v-.8zM104 115.911v.8l6.044-.978v-.8zM104 108.711v.622l6.044-.8v-.888zM104 101.244v.711l6.044-.888v-.8zM104 93.333v.711l6.044-.8v-.888zM104 85.6v.889l6.044-.978v-.889zM104 77.6v.8l6.044-.978v-.889z"
      opacity={0.05}
    />
    <path fill="#3A4C51" d="M102.933 68.622v6.4l89.956-16.266v-6.223z" />
    <path fill="#1F2E33" d="m102.756 68.622 90.133-16.089-51.289-35.2-90.133 16z" />
    <path fill="#101B20" d="M102.933 68.622v6.4L51.467 39.733v-6.4z" />
    <path
      fill="url(#dhl__illustrations_agreedplaceillustration_svg_c)"
      d="M74.667 149.245 104 144.178l-5.6-2.667-29.245 4.8z"
      opacity={0.5}
    />
    <path
      fill="url(#dhl__illustrations_agreedplaceillustration_svg_d)"
      d="m153.422 135.111 29.245-5.067-5.511-2.666-29.334 4.977z"
      opacity={0.5}
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_agreedplaceillustration_svg_a"
        x1={39.96}
        x2={48.031}
        y1={131.974}
        y2={116.133}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.269} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.511} stopColor="#181816" stopOpacity={0.364} />
        <stop offset={0.817} stopColor="#080807" stopOpacity={0.825} />
        <stop offset={0.933} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_agreedplaceillustration_svg_b"
        x1={94.901}
        x2={97.525}
        y1={129.438}
        y2={124.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.269} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.511} stopColor="#181816" stopOpacity={0.364} />
        <stop offset={0.817} stopColor="#080807" stopOpacity={0.825} />
        <stop offset={0.933} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_agreedplaceillustration_svg_c"
        x1={82.53}
        x2={90.602}
        y1={153.188}
        y2={137.347}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.269} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.511} stopColor="#181816" stopOpacity={0.364} />
        <stop offset={0.817} stopColor="#080807" stopOpacity={0.825} />
        <stop offset={0.933} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_agreedplaceillustration_svg_d"
        x1={161.234}
        x2={169.303}
        y1={139.072}
        y2={123.234}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.269} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.511} stopColor="#181816" stopOpacity={0.364} />
        <stop offset={0.817} stopColor="#080807" stopOpacity={0.825} />
        <stop offset={0.933} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
